module.exports = __webpack_public_path__ + "static/media/BlueLagon.dc10ea0d.png";